import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-round",
  "use": "icon-round-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-round\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0c282.765714 0 512 229.234286 512 512S794.777143 1024 512 1024 0 794.777143 0 512 229.234286 0 512 0z m0 64C264.571429 64 64 264.571429 64 512s200.571429 448 448 448 448-200.571429 448-448S759.428571 64 512 64z\" p-id=\"2572\" fill=\"#1890ff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/round.svg
// module id = Pgc4
// module chunks = 0